import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            CleanYarn <span className="text-accent-500">Dryclean</span>
          </h1>
          <p className="text-sm text-gray-500 mt-1">Admin Console</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
